var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83203 8.70938C3.83203 7.23584 3.83203 6.49907 4.22467 6.06935C4.36407 5.91678 4.5335 5.79466 4.72232 5.71066C5.25416 5.47406 5.95312 5.70705 7.35104 6.17302C8.41829 6.52877 8.95192 6.70665 9.49114 6.68823C9.68917 6.68147 9.88605 6.65511 10.0789 6.60952C10.6039 6.48541 11.072 6.1734 12.008 5.54937L13.3904 4.62778C14.5894 3.82843 15.1889 3.42876 15.8771 3.3366C16.5653 3.24444 17.2488 3.47229 18.6159 3.92799L19.7807 4.31624C20.7707 4.64625 21.2658 4.81126 21.5489 5.20409C21.832 5.59692 21.832 6.11871 21.832 7.16229V15.2907C21.832 16.7642 21.832 17.501 21.4394 17.9307C21.3 18.0833 21.1306 18.2054 20.9417 18.2894C20.4099 18.526 19.7109 18.293 18.313 17.827C17.2458 17.4713 16.7121 17.2934 16.1729 17.3118C15.9749 17.3186 15.778 17.3449 15.5852 17.3905C15.0601 17.5146 14.5921 17.8266 13.6561 18.4507L12.2737 19.3722C11.0747 20.1716 10.4751 20.5713 9.78696 20.6634C9.09877 20.7556 8.41522 20.5277 7.04812 20.072L5.88335 19.6838C4.89332 19.3538 4.3983 19.1888 4.11517 18.7959C3.83203 18.4031 3.83203 17.8813 3.83203 16.8377V8.70938Z",
    stroke: "#15528A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83203 6.63867V20.5",
    stroke: "#15528A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.832 3V17",
    stroke: "#15528A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.86e3d2ef1ccdb908a5d3ca156871a956.svg";
export { ForwardRef as ReactComponent };